export const Config ={

    api: 'https://api.quizwitz.com/'

};
